import auth from "./modules/auth";
import app from "./modules/app";
import account from "./modules/account";
import schedule from "./modules/schedule";
import notes from "./modules/notes";
import help from "./modules/help";
import usage from "./modules/usage";
import reports from "./modules/reports";
import sageAccounts from "./modules/sageAccounts";
import overrideDays from "./modules/overrideDays";

export default {
  auth,
  app,
  account,
  schedule,
  notes,
  help,
  usage,
  reports,
  sageAccounts,
  overrideDays,
};
